<template>
  <div class="app-container">
    <span style="font-size:18px;font-weight:bold">虚拟车管理</span>
    <hr style="margin-top: 5px;border:1px solid #bababa" />
    <div>
      <el-button class="filter-item btn-car-vir" style="margin-top: 10px;" type="primary" icon="el-icon-plus"
        @click="handleCreate">
        新建
      </el-button>
      <el-button class="filter-item btn-car-vir" style="margin-top: 10px;" type="primary" icon="el-icon-check"
        @click="startAllCar">
        一键开启
      </el-button>
      <el-button class="filter-item btn-car-vir" style="margin-top: 10px;" type="primary" icon="el-icon-caret-right"
        @click="moveAllCar">
        一键移动
      </el-button>
      <el-button class="filter-item btn-car-vir" style="margin-top: 10px;" type="primary" icon="el-icon-close"
        @click="stopAllCar">
        一键停止
      </el-button>
      <el-button class="filter-item btn-car-del" style="margin-top: 10px;" type="danger" icon="el-icon-delete"
        @click="deleteAllVRCar">
        一键删除
      </el-button>

      <el-input class="input-type1" clearable placeholder="请输入车辆ID或名称" prefix-icon="el-icon-search" maxlength="20"
        @input="e => listQuery = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')" v-model="listQuery"
        @keyup.enter.native="setCarList" :onkeyup="listQuery = listQuery.replace(/\s+/g,'')">
      </el-input>
    </div>

    <!-- 数据列表区 -->
    <el-table :data="tableData" style="width: 100%; margin:0 auto;align: center; margin-top:30px;" border
      :header-cell-style="tableHeaderColor" highlight-current-row>
      <el-table-column prop="idStr" label="车辆ID" width="180" align="center" header-align="center">
      </el-table-column>
      <el-table-column prop="name" label="车辆名称" width="180" align="center" header-align="center">
      </el-table-column>
      <el-table-column prop="type" label="车辆类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">robokit</span>
          <span v-else-if="scope.row.type === 2">扫地车</span>
          <span v-else>洗地机</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="type" label="车辆类型" width="200" align="center">
      </el-table-column> -->
      <el-table-column prop="longitude" label="经度" align="center">
      </el-table-column>
      <el-table-column prop="latitude" label="纬度" align="center">
      </el-table-column>

      <el-table-column prop="status" label="车辆状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">停止</span>
          <span v-else-if="scope.row.status === 1">开启</span>
          <span v-else-if="scope.row.status === 2">接管</span>
          <span v-else>移动</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="status" label="车辆状态" align="center" >
      </el-table-column> -->

      <el-table-column prop="createTime" label="创建时间" align="center">
        <template slot-scope="scope">{{scope.row.createTime| dateYMDHFormat}}</template>
      </el-table-column>
      <!-- <el-table-column prop="createTime" label="创建时间" align="center">
      </el-table-column> -->
      <el-table-column prop="operator" label="操作" width="100" align="center">
        <template v-slot:="{row,$index}">
          <el-select value="更多">
            <el-option v-for="(item, index) in tableOptions" :key="item" :value="index"
              @click.native="handleOperator(index, row)">
              {{item}}
            </el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <!-- <pagination-easy class="pagination_easy"></pagination-easy> -->

    <pagination-easy :total="totalCountsCar" @pagination="handlePageChangeCar" layout='prev, pager, next, jumper'
      :page="dataCarListReq.pageIndex" small :pager-count="5">
    </pagination-easy>

    <el-dialog title="新建虚拟车" :visible.sync="carTypeDialogVisableCreate" width="500px">
      <el-form :model="formCarData" label-position="right" label-width="100px">
        <el-form-item label="车辆类型:" prop="addtypeName">
          <el-select style="width:360px" v-model="data1" placeholder="请选择">
            <el-option v-for="item in options" :label="item.name" :key="item.id" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新建数量:" prop="addNumber">
          <el-input v-model="formCarData.addNumber" placeholder="请输入数量"
            @keyup.native="keyUpValidate(1,formCarData.addNumber)">
            </>
          </el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="carTypeDialogVisableCreate = false">返 回</el-button>
        <el-button type="primary" @click="createCar()">提 交</el-button>
      </div>
    </el-dialog>


    <!-- 编辑车辆 -->
    <el-dialog title="编辑虚拟车辆" :visible.sync="carTypeDialogVisable" width="500px">
      <el-form :model="formCarData" label-position="right" label-width="100px">
        <el-form-item label="车辆ID:" prop="addId">
          <el-input v-model="formCarData.addId" placeholder="请输入车辆ID" maxlength="20"
            @input="e => formCarData.addId = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="车辆名称:" prop="addName">
          <el-input v-model="formCarData.addName" placeholder="请输入车辆名称">
            </>
          </el-input>
        </el-form-item>
        <el-form-item label="车辆类型:" prop="addType">
          <el-select style="width:360px" v-model="data1" placeholder="请选择">
            <el-option v-for="item in options" :label="item.name" :key="item.id" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="车辆类型:" prop="addType">
          <el-input v-model="formCarData.addType" placeholder="请输入车辆类型"
            @keyup.native="keyUpValidate(4,formCarData.addType)">
            </>
          </el-input>
        </el-form-item> -->
        <el-form-item label="经度:" prop="addLongitude">
          <el-input v-model="formCarData.addLongitude" placeholder="请输入经度" :readonly="true">
            </>
          </el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="addLatitude">
          <el-input v-model="formCarData.addLatitude" placeholder="请输入纬度" :readonly="true">
            </>
          </el-input>
        </el-form-item>
        <el-form-item label="车辆状态:" prop="addStatusStr">
          <el-input v-model="formCarData.addStatusStr" placeholder="请输入车辆状态" :readonly="true">
            </>
          </el-input>
        </el-form-item>
        <el-form-item label="创建时间:" prop="addCreateTime">
          <el-input v-model="formCarData.addCreateTimeStr" placeholder="请输入创建时间" :readonly="true">
            </>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="carTypeDialogVisable = false">返 回</el-button>
        <el-button type="primary" @click="editCar()">提 交</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import paginationEasy from '@/components/common/Pagination'

  import {
    carSave,
    carEdit,
    deleteCarController,
    getVirtualCarList,
    doAction,
    deleteAllCar,
    getCarTypeAllList
  } from '@/api/car'

  export default {

    components: {
      paginationEasy
    },

    data() {
      return {

        // 查询框
        listQuery: '',

        // 车辆总数
        totalCountsCar: 30,

        //  车辆分页数据
        dataCarListReq: {
          pageIndex: 1,
          pageSize: 10,
        },

        // 错误标识
        error_input: false,

        // 选择类型数据
        data1: 1,
        options: [],

        carTypeDialogVisable: false,
        carTypeDialogVisableCreate: false,
        enbleSelect: true,
        tableOptions: [
          '编辑',
          '开启',
          '停止',
          '删除'
        ],
        dialogTitleType: 'create',
        formCarData: {
          addId: '',
          addName: '',
          addTypeName: '',
          addType: '',
          addNumber: '',
          addLongitude: '',
          addLatitude: '',
          addStatus: '',
          addStatusStr: '',
          addCreateTime: '',
          addCreateTimeStr: '',
        },

        tableHeight: '',

        tableData: [],

        actionObject: {
          idList: [],
          action: '',
        },

      }
    }, // data
    filters: {

    },
    created() {
      //  this.tableHeight = window.innerHeight - 500
    },
    methods: { // 修改table tr行的背景色
      tableRowStyle({
        row,
        rowIndex
      }) {
        return 'background-color: #f9f8ff'
      },

      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      // 修改table header的背景色
      tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (rowIndex === 0) {
          return 'background-color: #e8e8e8;color: #000000;font-weight: 500;'
        }
      },

      /**
       * 处理小车列表翻页
       * @param {Object} data
       */
      handlePageChangeCar(data) {
        console.log("当前页", data);
        this.dataCarListReq.pageIndex = data.page
        this.dataCarListReq.pageSize = data.limit
        this.setCarList();
      },


      // 格式化日期
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString() // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },

      setCarTypeAllList() {
        getCarTypeAllList().then(res => {

          this.options = res.data;

        })
      },

      /**
       * 添加列表数据
       */
      setCarList() {

        if (this.listQuery === '') {

          getVirtualCarList("list", this.dataCarListReq.pageIndex, this.dataCarListReq.pageSize, "0").then(res => {

            this.tableData = res.data;
            this.totalCountsCar = res.count;

          })
        } else {
          getVirtualCarList(this.listQuery, this.dataCarListReq.pageIndex, this.dataCarListReq.pageSize, "0").then(
            res => {

              this.tableData = res.data;
              this.totalCountsCar = res.count;

            })

        }

      },

      /**
       * 处理操作
       */
      handleOperator(index, row) {
        switch (index) {
          case 0:
            // index: 0 表示编辑车辆
            this.editType(row)
            break;
          case 1:
            // index: 1 开启车辆
            // this.handleDelete(row)
            this.startCar(row)
            break;
          case 2:
            // index: 2 表示停止车辆
            // this.handleDelete(row)
            this.stopCar(row)
            break;
          case 3:
            // index: 3 表示删车辆
            // this.handleDelete(row)
            this.deleteCar(row)
            break;
          default:
            break;
        }
      },

      /**
       * 新增按钮
       */
      handleCreate() {
        this.setCarTypeAllList();
        this.clearForm();
        this.data1 = 1;
        this.dialogTitleType = 'create';
        this.carTypeDialogVisableCreate = true;
        this.enbleSelect = false
      },

      /**
       * 清除输入框
       */
      clearForm() {
        this.formCarData.addName = '';
        this.formCarData.addTypeName = '';
        this.formCarData.addNumber = '';
        this.formCarData.addLongitude = '';
        this.formCarData.addLatitude = '';
        this.formCarData.addStatus = '';
        this.formCarData.addCreateTime = null;

      },

      /**
       * 	确定按钮事件处理
       */
      createCar() {
        this.check_inputs();
        if (this.dialogTitleType === 'create') {
          this.formCarData.addtypeId = null;
        }

        if (!this.error_input) {

          carSave(this.data1, this.formCarData).then(res => {

            if (res.result === '1') {
              this.$message({
                message: "添加车辆成功",
                type: 'info'
              })
              this.carTypeDialogVisable = false;
              this.setCarList();

            } else {
              this.$message({
                message: "网络异常，请重试",
                type: 'info'
              })
            }

          }) // saveCar
        }
      },

      /**
       * 修改确认按钮事件
       */
      editCar() {
        this.check_inputs();
        console.log(!this.error_input);
        if (this.dialogTitleType === 'edit') {
          carEdit(this.data1, this.formCarData).then(res => {

            if (res.result === '1' || res.result === '2' ||
              res.result === '0') {
              this.$message({
                message: res.message,
                type: 'info'
              })
              this.carTypeDialogVisable = false;
              this.setCarList();

            } else {
              this.$message({
                message: "网络异常，请重试",
                type: 'info'
              })

            }

          })
        }

      },

      deleteCar(row) {

        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteCarController(row.idStr).then(res => {

            if (res.result === '1' || res.result === '2') {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.setCarList();

            } else {
              this.$message({
                message: "网络异常，请重试",
                type: 'info'
              })

            }
          }) // deleteCarController
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      startCar(row) {
        let idListStr = [];
        idListStr.push(row.idStr);

        this.actionObject.idList = idListStr;
        this.actionObject.action = 1;
        this.doActionCar();
      },

      /**
       * 停止按钮事件处理
       */
      stopCar(row) {
        let idListStr = [];
        idListStr.push(row.idStr);

        this.actionObject.idList = idListStr;
        this.actionObject.action = 0;
        this.doActionCar();
      },


      /**
       * 一键开启按钮事件处理
       */
      startAllCar() {

        let idListStr = [];
        /* for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].status == 0) {
            idListStr.push(this.tableData[i].idStr);
          }
        } */
        this.actionObject.idList = idListStr;
        this.actionObject.action = 1;
        this.doActionCar();
      },


      /**
       * 一键移动按钮事件处理
       */
      moveAllCar() {
        let idListStr = [];
        /* for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].status == 1) {
            idListStr.push(this.tableData[i].idStr);
          }
        } */
        this.actionObject.idList = idListStr;
        this.actionObject.action = 3;
        this.doActionCar();
      },


      /**
       * 一键停止按钮事件处理
       */
      stopAllCar() {
        let idListStr = [];
       /* for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].status != 0) {
            idListStr.push(this.tableData[i].idStr);
          }
        } */
        this.actionObject.idList = idListStr;
        this.actionObject.action = 0;
        this.doActionCar();
      },

      /**
       * 操作按钮事件处理
       */
      doActionCar() {

        doAction(this.actionObject).then(res => {

          if (res.result === '1' || res.result === '2') {
            this.$message({
              message: "操作成功",
              type: 'info'
            })
            this.setCarList();

          } else if (res.result === '3') {

          } else {
            this.$message({
              message: "网络异常，请重试",
              type: 'info'
            })

          }
        }) // deleteCarController
      },

      /**
       * 删除全部车辆
       */
      deleteAllVRCar() {

        this.$confirm('此操作将永久删除全部车辆, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteAllCar().then(res => {

            if (res.result === '1' || res.result === '2') {
              this.$message({
                message: "操作成功",
                type: 'success'
              })
              this.setCarList();

            } else {
              this.$message({
                message: "网络异常，请重试",
                type: 'info'
              })

            }
          }) // deleteCarController

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },

      /**
       * 空值校验
       */
      check_inputs() {
        this.error_input = false;

        if (this.dialogTitleType === 'edit') {
          if (this.formCarData.addName === '') {
            this.$message({
              message: "名称不能为空",
              type: 'info'
            })
            this.error_input = true
            return
          }

        } else {
          if (this.formCarData.addNumber === '') {
            this.$message({
              message: "数量不能为空",
              type: 'info'
            })
            this.error_input = true
            return
          }
        }

      },

      keyUpValidate(index, value) {
        let returnVal = value;
        // 第一个字符不能是 '.'
        let validate1 = /^\./g;
        // 只能包含数字或 '.'
        let validate2 = /[^\d.]/g;
        if (validate1.test(value)) {
          this.$message.error('第一个字符不能是   .  ');
          returnVal = "";
        } else if (validate2.test(value)) {
          this.$message.error('只能包含数字或  . ');
          returnVal = value.slice(0, value.length - 1);
        } else if (value.split('.').length - 1 > 1) {
          this.$message.error('只能含有一个 小数点');
          returnVal = value.replace(/\.{2,}/g, '') // 只保留第一个. 清除多余的
          returnVal = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        }
        switch (index) {
          case 1:
            this.formCarData.addTypeNumber = returnVal
            break;
          case 3:
            this.formCarData.addTypeNumber = returnVal
            break;
          case 4:
            this.formCarData.addTypeNumber = returnVal
            break;
          default:
            this.$message.error('校验对象错误');
        }
      },

      /**
       * 编辑按钮事件处理
       */
      editType(row) {
        console.log(row);
        this.setCarTypeAllList();
        this.formCarData.addId = row.idStr;
        this.formCarData.addName = row.name;
        this.formCarData.addTypeName = row.type;
        this.data1 = row.type;
        if (row.type === 1) {
          this.formCarData.addType = 'robokit'
        } else if (row.type === 2) {
          this.formCarData.addType = '扫地车'
        } else {

          this.formCarData.addType = '洗地机'
        }
        this.formCarData.addLongitude = row.longitude;
        this.formCarData.addLatitude = row.latitude;
        this.formCarData.addStatus = row.status;

        if (row.status === 0) {
          this.formCarData.addStatusStr = '停止'
        } else if (row.status === 1) {
          this.formCarData.addStatusStr = '开启'
        } else if (row.status === 2) {
          this.formCarData.addStatusStr = '接管'
        } else {

          this.formCarData.addStatusStr = '移动'
        }
        this.formCarData.addCreateTime = row.createTime;

        this.formCarData.addCreateTimeStr = this.dateFormat("YYYY-mm-dd HH:MM", new Date(row.createTime));

        this.dialogTitleType = 'edit';
        this.carTypeDialogVisable = true;
        this.enbleSelect = true
      },


    }, //

    mounted() {
      this.setCarList();
      this.setCarTypeAllList();
    }
  }
</script>

<style>
  .input-type1 {
    float: right;
    margin-right: 2%;
    margin-top: 20px;
    width: 200px;

  }

  .pagination_easy {
    margin-top: 20px;
    /* margin-left: 10px; */
  }

  /* // 去掉横线 */
  .el-table__row>td {
    border: none;
  }

  .btn-car-vir {
    background-color: #94c8f9;
    border: none;
  }

  .btn-car-del {
    background-color: #bea1a1;
    border: none;
  }

  /* 去掉最下面的那一条线
  .el-table::before {
  	height: 0px;
  } */
</style>
